import { fetchVisitorsByIds } from "@/lib/services/visitor";
import { Visitor } from "@/lib/types/visitor";
import { defineStore } from "pinia";

interface VisitorState {
    visitors: Visitor[]
    loading: boolean
}

export const useVisitorsStore = () => {
    const inner = defineStore('visitors', {
        state: (): VisitorState => ({
            visitors: [],
            loading: false
        }),
        actions: {
            async fetchByIds(ids: string[]): Promise<void> {
                if (ids.length === 0) return

                this.loading = true

                try {
                    const res = await fetchVisitorsByIds(ids)
                    this.visitors = res
                } catch (err) {
                    console.error(err)
                } finally {
                    this.loading = false
                }
            },
        },
        getters: {
            getById: (state) => {
                return (id: string): Visitor | undefined => {
                    return state.visitors.find(visitor => visitor.id === id)
                }
            },
            getByIds: (state) => {
                return (ids: string[]): Visitor[] => {
                    return state.visitors.filter(visitor => ids.includes(visitor.id))
                }
            },
        },
    })

    const store = inner()

    return store
}